// extracted by mini-css-extract-plugin
export default {"search-box":"CustomSearchbox_search-box__mQXaO","query":"CustomSearchbox_query__IAWQh","search-icon":"CustomSearchbox_search-icon__kUsU2","x-icon":"CustomSearchbox_x-icon__SWBMR"};